import { queryKeys } from '@/lib/query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { billingClient } from '@/lib/api/ts-rest';
import { createLogger } from '@/lib/logger';

export function usePublishBillingRun() {
  const queryClient = useQueryClient();
  const log = createLogger('usePublishBillingRun');
  return useMutation({
    mutationFn: async (runId: string) => {
      const res = await billingClient.publishRun({ params: { id: runId } });
      if (res.status !== 201) throw new Error('Failed to publish');
      return res.body;
    },
    onSuccess: (_data, runId) => {
      queryClient.invalidateQueries({ queryKey: queryKeys.billing.run(runId) });
    },
    onError: (error) => {
      toast.error('La publication a échoué');
      log.error('Billing publish failed', { error });
    },
  });
}
